import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import { deleteCustomer } from "../../redux/AdminReducer";
import Swal from "sweetalert2";

import { RiDeleteBin6Line } from "react-icons/ri";

import EditVehicleDrawer from "../EditVehicleDrawer/EditVehicleDrawer";
import { useState } from "react";
import { useEffect } from "react";
import { getAllVehicles } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";
import { deleteVehicle } from "../../redux/AdminReducer";
import EditDriverDrawer from "../EditDriverDrawer/EditDriverDrawer";
import { getAllDrivers } from "../../redux/AdminReducer";
import { deleteDriver } from "../../redux/AdminReducer";
import { getCustomers } from "../../redux/AdminReducer";
import EditCusomerDriver from "../EditCustomerDrawer/EditCustomerDrawer";
export default function TableDateCustomers() {
  const [deleteVeh, setDeleteVeh] = useState(0);

  const dispatch = useDispatch();
  const [alertIndex, setAlertIndex] = useState();

  const vehicleData = useSelector(
    (state) => state?.AdminReducer?.allVehiclesData
  );
  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );
  const customerData = useSelector(
    (state) => state?.AdminReducer?.getCustomersData
  );

  console.log("vehicleData", vehicleData);
  

  const deleteIconClicked = (index) => {
    setAlertIndex(index);

    setDeleteVeh(1);
  };

  const noClickedAlert = () => {
    setDeleteVeh(2);
  };

  useEffect(() => {
 
    dispatch(getAllDrivers());
    dispatch(getCustomers());
    
  }, []);

  console.log("customerData",customerData)
  const yesDeleteClicked = async (data) => {
    let id = data._id;

    const response = await dispatch(deleteCustomer({ id, customerData }));

    console.log("responseDeletedVehicle", data);

    setDeleteVeh(2);
  };


  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Email</TableCell>
              <TableCell align="right">Phone</TableCell>
              
              
              <TableCell align="right">Delete</TableCell>
              <TableCell align="right">Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {customerData?.map((row, index) => (
              <TableRow
                key={row?.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row?.name}
                </TableCell>
                <TableCell align="right">{row?.email}</TableCell>
                <TableCell align="right">{row?.phone}</TableCell>
       
              
              
                <TableCell align="right">
                  <RiDeleteBin6Line
                    onClick={() => deleteIconClicked(index)}
                    className="deleteVehicleIcon"
                  />
                </TableCell>
                <TableCell align="right" className="editColDataVeh">
                  {/* <FiEdit2/> */}

                  {/* <EditVehicleDrawer data={row}/> */}

                  {/* <EditDriverDrawer data={row}/> */}
                
                  <EditCusomerDriver data={row}/>
                </TableCell>

                {deleteVeh === 1 && alertIndex === index && (
                  <div className="mainDeleteCardVehicle">
                    <div className="confirmTxtAlertVehDlt">
                      {" "}
                      You want to delete Customer?
                    </div>
                    <div className="topConfirmBtnDeltVeh">
                      <div
                        className="noBtnAlertDltVeh"
                        onClick={noClickedAlert}
                      >
                        No
                      </div>
                      <div
                        className="yesBtnAlertDltVeh"
                        onClick={() => yesDeleteClicked(row)}
                      >
                        Yes
                      </div>
                    </div>
                  </div>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
